import { PaymentPartnerType } from '@/__generated';
import { useGetCompanyPaymentPartners } from '@/hooks/data/masterDataHook';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {
  partnerType?: PaymentPartnerType;
}

/** Partenaire de paiement d'un compte de la compagnie : partenaires du pays de la compagnie, du type choisi. */
export default function PaymentPartnerInput({ partnerType, ...props }: Props) {
  const { data, isLoading } = useGetCompanyPaymentPartners(partnerType);

  return (
    <Select
      maxTagCount="responsive"
      allowClear
      loading={isLoading}
      disabled={!partnerType}
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {data?.partners?.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {c.name}
          </Select.Option>
        );
      })}
    </Select>
  );
}
